import axios from 'axios';
import { triggerExpired } from 'app/utils/utils';

let isLoginPopupShown = false;

const axiosInstance = axios.create({
  timeout: 0,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !isLoginPopupShown) {
        isLoginPopupShown = true;
        triggerExpired();
    }
    return Promise.reject((error.response && error.response.data) || 'Something went wrong!')
  }
);

export default axiosInstance;
